/**
 * Breakpoint tokens. Min-width, mobile-first. See PLAN.md §3.6 for the
 * responsive principles + `Genesis / Sample Workspaces` for the chosen
 * visual contract + the `agentis-frontend-architecture` skill (R10 + R11)
 * for the compact-tier shell pattern.
 */
export const breakpoints = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1440,
} as const;

export type BreakpointsToken = typeof breakpoints;
export type BreakpointKey = keyof BreakpointsToken;
